import { Problem, ProblemDetectionContext, ProblemType, ProblemSeverity } from '../types';

export function detectQueueDurationIssues(context: ProblemDetectionContext, generateId: () => string): Problem[] {
  const problems: Problem[] = [];
  const { logs } = context;

  // Look for queue-related logs and calculate duration
  // Add defensive checks to prevent errors when properties are undefined
  const queueLogs = logs.filter(
    (log) =>
      log.LogData?.ResourceName?.toLowerCase().includes('queue') ||
      log.EventType?.includes('Queue') ||
      log.LogData?.Action?.Type === 'TransferContactToAgent'
  );

  if (queueLogs.length > 0) {
    const firstQueueLog = queueLogs[0];
    const lastQueueLog = queueLogs[queueLogs.length - 1];

    const duration = new Date(lastQueueLog.AbsoluteTime).getTime() - new Date(firstQueueLog.AbsoluteTime).getTime();
    const durationSeconds = duration / 1000;

    if (durationSeconds > 300) {
      // 5+ minutes
      const originalIndex = logs.indexOf(firstQueueLog);
      problems.push({
        id: generateId(),
        type: ProblemType.HIGH_QUEUE_DURATION,
        severity: ProblemSeverity.HIGH,
        title: 'High Queue Duration Detected',
        description: `Customer was in queue for ${Math.round(durationSeconds)} seconds (${Math.round(durationSeconds / 60)} minutes)`,
        timestamp: firstQueueLog.AbsoluteTime,
        source: 'IVR_LOG',
        relatedData: { duration: durationSeconds, logs: queueLogs },
        suggestions: [
          'Review agent availability during this time period',
          'Check queue configuration and routing rules',
          'Consider implementing callback functionality'
        ],
        index: originalIndex >= 0 ? originalIndex : undefined
      });
    }
  }

  return problems;
}
